export default function IconArr(props: any) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M5.27921 20.3233C5.32954 20.6547 5.61445 20.8996 5.94965 20.8996H18.708C19.0432 20.8996 19.3281 20.6547 19.3784 20.3233L21.1444 8.69336L16.1263 11.4059L12.3288 5.30273L8.53131 11.4059L3.51318 8.69336L5.27921 20.3233Z"
                fill="#FCB929"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M6.7169 17.5776C6.75228 17.9236 7.0437 18.1867 7.3915 18.1867H17.2635C17.6113 18.1867 17.9027 17.9236 17.9381 17.5776L18.4306 12.7617L15.4099 14.118L12.3275 9.37109L9.2451 14.118L6.22437 12.7617L6.7169 17.5776Z"
                fill="#FFE58C"
            />
            <circle cx="3.5125" cy="8.69219" r="1.35625" fill="#FCB929" />
            <circle cx="12.3294" cy="4.62383" r="1.35625" fill="#FCB929" />
            <circle cx="21.1438" cy="8.69219" r="1.35625" fill="#FCB929" />
        </svg>
    );
}
